import { render, staticRenderFns } from "./StreamedWagesList.vue?vue&type=template&id=b7a273ee&"
import script from "./StreamedWagesList.vue?vue&type=script&setup=true&lang=js&"
export * from "./StreamedWagesList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports